import { FC, useState } from 'react';
import './tab-view.scss';

export type Tab = {
  label: string;
  content: React.ReactNode;
};

export type TabViewProps = {
  tabs: Tab[];
  onTabSwitch?: (index: number) => void;
  init?: number;
  /* 'embedded' renders a segmented/pill tab bar to signal these sit inside a parent tab */
  variant?: 'default' | 'embedded';
};

export const TabView: FC<TabViewProps> = ({ tabs, onTabSwitch, init, variant = 'default' }) => {
  const [activeIndex, setActiveIndex] = useState(init ?? 0);

  return (
    <div className={`tab-view${variant === 'embedded' ? ' tab-view--embedded' : ''}`}>
      <div className="tab-bar">
        {tabs.map((tab, i) => (
          <div
            key={tab.label}
            className={i === activeIndex ? 'active-tab tab' : 'tab'}
            onClick={() => {
              if (onTabSwitch) onTabSwitch(i);
              setActiveIndex(i);
            }}
          >
            <h3>{tab.label}</h3>
          </div>
        ))}
      </div>
      {tabs.map((tab, i) => (
        <div
          key={tab.label}
          className="tab-content"
          style={{
            display: i === activeIndex ? undefined : 'none'
          }}
        >
          {tab.content}
        </div>
      ))}
    </div>
  );
};
